// extracted by mini-css-extract-plugin
export default {"main_div":"FormModal_main_div__KQW3h","error_msg":"FormModal_error_msg__Osv+S"};